"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initAlfaMetrics = void 0;
var config_1 = require("./config");
var tracker_1 = require("./tracker");
/**
 * Создает трекер на странице и инициализирует конфиг с событиями
 */
function initAlfaMetrics(_a) {
    var appId = _a.appId, config = _a.config, userId = _a.userId, _b = _a.type, type = _b === void 0 ? 'retail' : _b, _c = _a.platform, platform = _c === void 0 ? 'web' : _c;
    tracker_1.createTracker({
        appId: appId,
        platform: platform,
        type: type,
        userId: userId,
    });
    config_1.initAnalyticsConfig(config);
}
exports.initAlfaMetrics = initAlfaMetrics;

//# sourceMappingURL=init-alfa-metrics.js.map
